import { gql } from "graphql-tag";

export const listOfFacets = gql`
  fragment Collection_page_list_of_facets on Collection_pageBodyList_of_facets {
    type
    primary {
      title1
    }
    fields {
      shop_by_facets {
        _linkType
        __typename
        ... on Collection_facet {
          collection_uid
          facet_title
        }
      }
    }
  }
`;
